import { useTranslation } from 'react-i18next'

import { AIButtonText } from '../../../AIButton'
import Text from '../../../Text'
import { QA_NAME_GRETA_AI_CHAT_PROJECTS_RETRY } from '../../GretaAIChat.constants'

import * as styles from './GretaAIChatChatListProjectsError.module.css'

function GretaAIChatChatListProjectsError({ onRetry = null }) {
  const { t } = useTranslation()

  return (
    <div className={styles.error}>
      <Text isSecondary className={styles.text}>
        {t('Greta.ProjectsLoadErrorKey')}
      </Text>
      {onRetry ? (
        <AIButtonText
          qaName={QA_NAME_GRETA_AI_CHAT_PROJECTS_RETRY}
          text={t('Greta.RetryButtonKey')}
          onClick={onRetry}
        />
      ) : null}
    </div>
  )
}

export default GretaAIChatChatListProjectsError
